import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";

class Login extends Component {
  constructor() {
    super();
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.notificar = this.notificar.bind(this);
    this.toggle = this.toggle.bind(this);
    this.recuperarSenha = this.recuperarSenha.bind(this);
    this.state = {
      login: "",
      password: "",
      error: false,
      modal: false,
      loginRecuperar: "",
      emailRecuperar: "",
      hash: "",
    };
  }

  async componentDidMount() {
    let hashLocal = localStorage.getItem("hash");
    let ultimoLoginStr = localStorage.getItem("ultimoLogin");

    if (ultimoLoginStr !== null && ultimoLoginStr !== "") {
      let ultimoLogin = JSON.parse(ultimoLoginStr);
      this.setState({ login: ultimoLogin.login });
    }

    if (hashLocal === null) {
      hashLocal = uuidv4();
      localStorage.setItem("hash", hashLocal);
    }

    this.setState({ hash: hashLocal });
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      loginRecuperar: this.state.login,
    });
  }

  handleChangeInput(e) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({
      [e.target.id]: value,
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    let localLogin = this.state.login;
    let toSend = {
      login: localLogin,
      password: this.state.password,
      hash: this.state.hash,
    };

    await axios
      .post(`${this.props.getBaseUrlApi()}/login`, toSend)
      .then(async (res) => {
        //TODO: AXIOS
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("descricaoVendedor", res.data.descricaoUsuario);
        localStorage.setItem("cargoVendedor", res.data.cargoUsuario);
        localStorage.setItem(
          "idIntegracaoVendedor",
          res.data.idIntegracaoUsuario
        );
        localStorage.setItem("idUsuario", res.data.idUsuario);
        localStorage.setItem("codUsuario", res.data.codUsuario);
        localStorage.setItem(
          "usuarioVendedores",
          JSON.stringify(res.data.usuarioVendedores)
        );
        delete toSend.password;
        localStorage.setItem("ultimoLogin", JSON.stringify(toSend));
        if (res.data.imagem !== null) {
          localStorage.setItem("imagem", res.data.imagem);
        }

        let validarEstoque = res.data.parametros.validarEstoque;
        let permitirAlterarCondicaoPagamento =
          res.data.parametros.permitirAlterarCondicaoPagamento;

        if (validarEstoque === undefined) {
          validarEstoque = true;
        }

        if (permitirAlterarCondicaoPagamento === undefined) {
          permitirAlterarCondicaoPagamento = true;
        }

        localStorage.setItem("validarEstoque", validarEstoque);
        localStorage.setItem(
          "permitirAlterarCondicaoPagamento",
          permitirAlterarCondicaoPagamento
        );
        localStorage.setItem("perfil", JSON.stringify(res.data.perfil));

        this.props.history.push("/home");
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          this.notificar("warning", error.response.data.erro);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  recuperarSenha() {
    let toSend = {
      login: this.state.loginRecuperar,
      email: this.state.emailRecuperar,
    };

    if (toSend.login === "" || toSend.email === "") {
      this.notificar("warning", "Favor preencher os campos corretamente!");
      return false;
    }

    axios
      .post(`${this.props.getBaseUrlApi()}/recuperar-senha`, toSend)
      .then(async (res) => {
        //TODO: AXIOS
        console.log(res);
        this.notificar("success", "Email de recuperação de senha enviado.");
        this.toggle();
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
          console.log("felipe", error.response.data.erro);
          this.notificar("warning", error.response.data.erro.erro);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
        console.log(error.config);
      });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller">
          <div className="container-fluid page-body-wrapper full-page-wrapper">
            <div className="content-wrapper d-flex align-items-center auth px-0">
              <div className="row w-100 mx-0">
                <div className="col-lg-4 mx-auto">
                  <div
                    className="brand-logo text-center"
                    style={{
                      backgroundColor: "#7d3e7a",
                      marginBottom: "0",
                      padding: "25px",
                    }}
                  >
                    <img src="../../images/logo-branca-nova.png" alt="logo" />
                  </div>
                  <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                    <form className="pt-3">
                      <div
                        className="form-group"
                        style={{ position: "relative" }}
                      >
                        <i
                          className="fa fa-user"
                          style={{
                            position: "absolute",
                            top: "9px",
                            left: "5px",
                            fontSize: "20px",
                          }}
                        ></i>
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          id="login"
                          placeholder="LOGIN"
                          onChange={this.handleChangeInput}
                          value={this.state.login}
                          style={{ paddingLeft: "25px" }}
                        />
                      </div>
                      <div
                        className="form-group"
                        style={{ position: "relative" }}
                      >
                        <i
                          className="fa fa-lock"
                          style={{
                            position: "absolute",
                            top: "11px",
                            left: "5px",
                            fontSize: "20px",
                          }}
                        ></i>
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          id="password"
                          placeholder="SENHA"
                          onChange={this.handleChangeInput}
                          value={this.state.password}
                          style={{ paddingLeft: "25px" }}
                        />
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn teste8"
                          onClick={this.handleSubmit}
                          type="button"
                        >
                          ENTRAR
                        </button>
                      </div>
                      {/* <div className="my-2 d-flex justify-content-between align-items-center">
                        <a
                          href="#"
                          className="auth-link text-black"
                          style={{
                            width: "100%",
                            float: "left",
                            textAlign: "center",
                            paddingTop: "5px",
                            color: "#908787",
                            fontSize: "13px",
                          }}
                          onClick={() => this.toggle()}
                        >
                          Esqueceu sua senha? clique aqui
                        </a>
                      </div> */}
                      <div className="my-2 d-flex justify-content-between align-items-center">
                        <span
                          className="width-100"
                          style={{ fontSize: "13px", textAlign: "center" }}
                        >
                          v6.6.1
                        </span>
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "100%",
                          paddingTop: "20px",
                        }}
                      >
                        <img
                          src="../../images/logo-suricatto-nova.png"
                          alt="logo"
                          style={{ width: "100px" }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Recuperar Senha</ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label>Login</label>
              <input
                type="text"
                className="form-control"
                id="loginRecuperar"
                value={this.state.loginRecuperar}
                onChange={this.handleChangeInput}
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                id="emailRecuperar"
                value={this.state.emailRecuperar}
                onChange={this.handleChangeInput}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="btn-modal-recuperar"
              color="secondary"
              onClick={this.toggle}
            >
              Cancelar
            </Button>
            <Button
              className="btn-modal-recuperar"
              color="primary"
              onClick={this.recuperarSenha}
            >
              Enviar
            </Button>{" "}
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Login;
